import { memo } from "react";
import { useTranslation } from "@coworker/locales";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";

interface ConfirmDeleteCommentPromptProps {
  visible: boolean;
  disabled: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmDeleteCommentPrompt = memo(
  ({
    visible,
    disabled,
    onCancel,
    onConfirm,
  }: ConfirmDeleteCommentPromptProps) => {
    const { t } = useTranslation();

    return (
      <FixaModal handleCloseBtn={onCancel} visible={visible}>
        <FixaPrompt
          footer={
            <FixaModalFooter>
              <FixaButton type="secondary" disabled={false} onClick={onCancel}>
                {t("cancelString")}
              </FixaButton>
              <FixaButton
                type="primary"
                disabled={disabled}
                onClick={onConfirm}
              >
                {t("yesDeleteCommentString")}
              </FixaButton>
            </FixaModalFooter>
          }
          header={<FixaModalHeader title="" />}
          title={t("areYouSureYouWantToDeleteThisCommentString")}
          aria-label={t("areYouSureYouWantToDeleteThisCommentString")}
          titleId="confirmDeleteComment"
          children={null}
        />
      </FixaModal>
    );
  }
);
